import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
  Injectable,
} from '@angular/core';
import {
  provideRouter,
  RouterModule,
  RouterOutlet,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
  withPreloading,
  withRouterConfig,
  withViewTransitions,
} from '@angular/router';
import { SelectivePreloadingStrategy } from './core/strategies/selective-preloading.strategy';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { App_Route } from './app.routes';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { ToastrModule } from 'ngx-toastr';
import { ColorPickerModule } from 'ngx-color-picker';
import { FlatpickrDefaults } from 'angularx-flatpickr';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { AngularFireDatabaseModule } from '@angular/fire/compat/database';
import { GALLERY_CONFIG, GalleryConfig } from 'ng-gallery';
import { errorInterceptorFn } from './core/interceptors/error.interceptor';
import { authInterceptor } from './features/auth/services/auth.interceptor';
import { initializePermissions } from './shared/services/permission-initializer';
import { IntlService, CldrIntlService } from '@progress/kendo-angular-intl';

@Injectable()
class MondayFirstIntlService extends CldrIntlService {
  public override firstDay(): number {
    return 1; // Monday
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      App_Route,
      // withPreloading(SelectivePreloadingStrategy),
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled',
      }),
      withRouterConfig({
        onSameUrlNavigation: 'reload',
        paramsInheritanceStrategy: 'always',
      })
    ),
    provideClientHydration(),
    RouterOutlet,
    RouterModule,
    BrowserModule,
    provideAnimations(),
    FlatpickrDefaults,
    AngularFireDatabaseModule,
    BrowserModule,
    {
      provide: GALLERY_CONFIG,
      useValue: {
        autoHeight: true,
        imageSize: 'cover',
      } as GalleryConfig,
    },
    AngularFirestoreModule,

    provideHttpClient(withFetch(), withInterceptors([authInterceptor, errorInterceptorFn])),
    {
      provide: APP_INITIALIZER,
      useFactory: initializePermissions,
      multi: true,
    },
    AngularFireAuthModule,
    { provide: IntlService, useClass: MondayFirstIntlService },
    provideZoneChangeDetection({ eventCoalescing: true }),
    importProvidersFrom(
      ColorPickerModule,
      ToastrModule.forRoot({
        timeOut: 15000, // 15 seconds
        closeButton: true,
        progressBar: true,
      })
    ),
  ],
};
